export default {"src":"/_next/static/media/IMG_9289.02c4c4e6.JPG","height":1481,"width":2222};